




















































































































































































import StatementAccountInfo from "../StatementAccountInfo.vue";
import CommonIconBtn from "@/components/Common/CommonIconBtn.vue";
import { inSettlementApi, submitSettlementApi, getAgentContractAccountApi } from "@/api/index";
import { Component, Vue, Prop, ModelSync, Watch } from "vue-property-decorator";
import { getCurrentDateTime, getDateTimeFormat } from "@/utils/function_utils";

@Component({
  name: "submissionSettledDialog",
  components: {
    CommonIconBtn,
    StatementAccountInfo,
  },
})
export default class extends Vue {
  @ModelSync("dialogSubmitSettledVisible", "changeVisible", { type: Boolean })
  public value!: boolean;

  @Prop() public readonly data!: any;

  public dealDate = "";
  public accountInfo = {
    bankName: "",
    bankBranchName: "",
    bankAccount: "",
    bankAccountNum: "",
    bankAddress: "",
    bankCodeType: "",
    bankCode: "",
    countryName: "",
    contractNum: "",
    fkCurrencyTypeNum: "",
  };
  public loading = false;
  public specialCurrency: string[] = []; // CNY/AED/NZD
  public currencyOptions: any[] = [];
  public sourceCurrencyOptions: any[] = [];
  public agentContractAccount: any[] = [];
  public settleMethod: string = ""; // 结算方式

  public formData: any = {
    fkAgentContractAccountId: "",
    optGuid: "",
    flag: true,
    remark: "",
    settlementCurrencyVoList: [
      {
        settlementCurrencyTypeNum: "", // 结算币种编号
        sourceCurrencyTypeNum: "", // 原币种编号
        key: new Date().getTime() + "",
        settlementModel: '',
      },
    ],
    studentAccommodationSubmitSettlementVoList: [
      {
        fkPayablePlanId: 0,
        statusSettlement: 0,
      },
    ],
    studentInsuranceSubmitSettlementVoList: [
      {
        fkPayablePlanId: 0,
        statusSettlement: 0,
      },
    ],
    studentOfferItemSettlementItemVoList: [
      {
        fkPayablePlanId: 0,
        statusSettlement: 0,
      },
    ],
    studentServiceFeeSubmitSettlementVoList: [
      {
        fkPayablePlanId: 0,
        statusSettlement: 0,
      },
    ],
  };

  @Watch("dialogSubmitSettledVisible", { deep: true })
  public watchDialogVisible(val: boolean) {
    if (val) {
      console.log(this.data);
      this.dealDate = getCurrentDateTime();
      this.getAgentContractAccount();
      this.getSourceCurrency();
    }
  }

  public async getAgentContractAccount() {
    try {
      const { data } = await getAgentContractAccountApi();
      this.agentContractAccount = data.data;
    } catch (err) {
      //
    }
  }
  public getSourceCurrency() {
    const data = this.data;
    const setObj = new Set();
    const specialCurrency: string[] = [];
    data.offerItem.forEach((item: any) => {
      setObj.add(item.fkCurrencyTypeNum);
    });
    // 暂时只需要留学申请部分
    // data.insurance.forEach((item: any) => {
    //   setObj.add(item.fkCurrencyTypeNum);
    // });
    // data.serviceFee.forEach((item: any) => {
    //   setObj.add(item.fkCurrencyTypeNum);
    // });
    // data.accommodation.forEach((item: any) => {
    //   setObj.add(item.fkCurrencyTypeNum);
    // });
    this.sourceCurrencyOptions = Array.from(setObj);
    this.sourceCurrencyOptions.map((item: any) => {
      if (["CNY", "AED", "NZD"].includes(item)) {
        specialCurrency.push(item);
      }
    });
    this.specialCurrency = specialCurrency;
  }

  // 新增币种选项
  public handleAddSettlementCurrency() {
    this.formData.settlementCurrencyVoList.push({
      settlementCurrencyTypeNum: "", // 结算币种编号
      sourceCurrencyTypeNum: "", // 原币种编号
      key: new Date().getTime() + "",
      settlementModel: '',
    });
  }
  // 删除币种选项
  public handleDeleteSettlementCurrency(index: number) {
    this.formData.settlementCurrencyVoList.splice(index, 1);
  }
  /**
   * @description 选择账户
   * @param {number | string} id
   * @returns {void}
   * 外币国外账户：
   *  所选结算单有 CNY/AED 的情况下（原币种），只能选择 USD/GBP/AUD/SGD/HKD  以及 非CNY/AED 的账单内已有币种结算（结算币种）
   * 外币国内账户：
   *  所选结算单有 CNY/AED/NZD 的情况下（原币种），只能选择 USD/GBP/AUD/SGD/HKD 以及 非CNY/AED/NZD 的账单内已有币种结算（结算币种）
   * 人民币账户：只能选择 CNY（人民币）结算
   * 没有以上情况则从所选账单已有币种结算
   */
  public changeBankAccount(id: number | string) {
    this.formData.settlementCurrencyVoList = [
      {
        settlementCurrencyTypeNum: "", // 结算币种编号
        sourceCurrencyTypeNum: "", // 原币种编号
        key: new Date().getTime() + "",
        settlementModel: '',
      },
    ];
    if (!id) {
      return;
    }
    const item = this.agentContractAccount.find((account) => account.id === id);
    const currencyTypeNum = item.fkCurrencyTypeNum; // 所选银行账户币种
    const specialCurrency = this.specialCurrency;
    // 人民币账户
    if (currencyTypeNum === "CNY") {
      this.currencyOptions = ["CNY"];
      const settlementCurrencyVoList = this.formData.settlementCurrencyVoList;
      settlementCurrencyVoList[0].settlementCurrencyTypeNum = "CNY";
      this.settleMethod = 'UCS';
      this.formData.settlementCurrencyVoList = settlementCurrencyVoList;
      // 外币国内账户（swiftcode 的第五六位字母为国家代码CN的）HSBCCNHHHKH
    } else if (
      item.bankCodeType === "SwiftCode" &&
      item.bankCode.length &&
      item.bankCode.substring(4, 2) === "CN" &&
      specialCurrency.length
    ) {
      const currencyOptions: string[] = [];
      this.sourceCurrencyOptions.map((num) => {
        if (
          !specialCurrency.includes(num) &&
          !["USD", "GBP", "AUD", "SGD", "HKD"].some((n) => num === n)
        ) {
          currencyOptions.push(num);
        }
      });
      this.currencyOptions = [
        "USD",
        "GBP",
        "AUD",
        "SGD",
        "HKD",
        ...currencyOptions,
      ];
      // 外币国外账户 NZD不是特殊币种
    } else if (specialCurrency.length > 1 || (specialCurrency.length === 1 && specialCurrency[0] !== "NZD")) {
      const currencyOptions: string[] = [];
      this.sourceCurrencyOptions.map((num) => {
        if (
          (!specialCurrency.includes(num) || num === "NZD") &&
          !["USD", "GBP", "AUD", "SGD", "HKD"].some((n) => num === n)
        ) {
          currencyOptions.push(num);
        }
      });
      this.currencyOptions = [
        "USD",
        "GBP",
        "AUD",
        "SGD",
        "HKD",
        ...currencyOptions,
      ];
    } else {
      this.currencyOptions = this.sourceCurrencyOptions;
    }
    this.accountInfo = item;
  }
  /**
   * @description 选择结算方式
   * @param {number | string} val 1不同 2统一
   * @returns {void}
   */
  public changeSettleMethod(val: number | string) {
    this.formData.settlementCurrencyVoList = [
      {
        settlementCurrencyTypeNum: "", // 结算币种编号
        sourceCurrencyTypeNum: "", // 原币种编号
        key: new Date().getTime() + "",
      },
    ];
  }

  public async submitAndESign() {
    if (this.loading) {
      return;
    }
    const formData = this.formData;
    if (!formData.fkAgentContractAccountId) {
      this.$message.warning(this.$t("message.pleaseSelectBankInfo") as string);
      return;
    } else if (!this.settleMethod) {
      this.$message.warning(
        this.$t("message.pleaseSelectSettleMethod") as string
      );
      return;
    }
    if (this.settleMethod === 'SDC') {
      if (formData.settlementCurrencyVoList.length < this.sourceCurrencyOptions.length) {
        this.$message.warning(this.$t("message.pleaseCompleteSettleInfo") as string);
        return;
      } else {
        for (const settleCurrency of formData.settlementCurrencyVoList) {
          if (!settleCurrency.sourceCurrencyTypeNum) {
            this.$message.warning(
              this.$t("message.pleaseCompleteSettleInfo") as string
            );
            return;
          }
          if (!settleCurrency.settlementCurrencyTypeNum) {
            this.$message.warning(
              this.$t("message.pleaseCompleteOriginalCurrency") as string
            );
            return;
          }
        }
      }
    } else {
      if (!formData.settlementCurrencyVoList[0].settlementCurrencyTypeNum) {
        this.$message.warning(
          this.$t("message.pleaseCompleteOriginalCurrency") as string
        );
        return;
      }
    }
    this.loading = true;
    const params = this.getSubmitFormData();
    try {
      const { data } = await submitSettlementApi(params);
      const offerItem = data.data[0].studentOfferItemCommissionDtoList.map((v: any) => {
        return {
          fkPayablePlanId: v.id,
          statusSettlement: v.statusSettlement,
        }
      });
      const submitData = {
        flag: false,
        optGuid: data.data[0].optGuid,
        fkAgentContractAccountId: data.data[0].fkAgentContractAccountId,
        studentOfferItemSettlementItemVoList: offerItem,
        studentInsuranceSubmitSettlementVoList: [], // insurance,
        studentServiceFeeSubmitSettlementVoList: [], // serviceFee,
        studentAccommodationSubmitSettlementVoList: [], // accommodation,
        studentOfferItemCommissionDtoList: data.data[0].studentOfferItemCommissionDtoList,
        studentInsuranceCommissionDtoList: [],
        studentServiceFeeCommissionDtoList: [],
        studentAccommodationCommissionDtoList: [],
      };
      this.$emit('get-submit-data', submitData);
      this.$message.success(this.$t('common.submitSuccess') as string);
      this.handleClose();
      // if (res) {
        // const dateTime = (new Date()).getTime();
      //   const blob = new Blob([res.data]);
      //   const elink = document.createElement("a");
      //   elink.download = getDateTimeFormat(dateTime);
      //   elink.style.display = "none";
      //   elink.href = URL.createObjectURL(blob);
      //   document.body.appendChild(elink);
      //   elink.click();
      //   URL.revokeObjectURL(elink.href); // 释放URL 对象
      //   document.body.removeChild(elink);
      //   this.$message.success(this.$t('message.submitAndDownloadSuccess') as string);
      //   this.$emit('set-time', dateTime)
      //   this.handleClose();
      // }
    } catch (err) {
      this.loading = false;
    }
  }

  public getSubmitFormData(): any {
    const formData = this.formData;
    const data = this.data;
    const offerItem = data.offerItem.reduce((pre: any, cur: any) => {
      pre.push({
        fkPayablePlanId: cur.id,
        statusSettlement: cur.statusSettlement,
      });
      return pre;
    }, []);
    // 暂时只需要留学申请部分
    // const insurance = data.insurance.reduce((pre: any, cur: any) => {
    //   pre.push({
    //     fkPayablePlanId: cur.id,
    //     statusSettlement: cur.statusSettlement,
    //   });
    //   return pre;
    // }, []);
    // const serviceFee = data.serviceFee.reduce((pre: any, cur: any) => {
    //   pre.push({
    //     fkPayablePlanId: cur.id,
    //     statusSettlement: cur.statusSettlement,
    //   });
    //   return pre;
    // }, []);
    // const accommodation = data.accommodation.reduce((pre: any, cur: any) => {
    //   pre.push({
    //     fkPayablePlanId: cur.id,
    //     statusSettlement: cur.statusSettlement,
    //   });
    //   return pre;
    // }, []);
    if (this.settleMethod === 'UCS') {
      const allCounts = this.sourceCurrencyOptions;
      const currencyNum =
        formData.settlementCurrencyVoList[0].settlementCurrencyTypeNum;
      // formData.settlementCurrencyVoList[0].sourceCurrencyTypeNum = currencyNum;
      const arr = [];
      for (let i = 0; i < allCounts.length; i++) {
        arr.push({
          settlementCurrencyTypeNum: currencyNum, // 结算币种编号
          sourceCurrencyTypeNum: allCounts[i], // 原币种编号
          settlementModel: this.settleMethod,
        });
      }
      formData.settlementCurrencyVoList = arr;
    } else {
      formData.settlementCurrencyVoList.forEach((item: any) => {
        item.settlementModel = this.settleMethod;
      });
    }
    formData.remark = this.data.remark;
    formData.studentOfferItemSettlementItemVoList = offerItem;
    formData.studentInsuranceSubmitSettlementVoList = [] // insurance;
    formData.studentServiceFeeSubmitSettlementVoList = [] // serviceFee;
    formData.studentAccommodationSubmitSettlementVoList = [] // accommodation;
    formData.studentOfferItemCommissionDtoList = data.offerItem;
    formData.studentInsuranceCommissionDtoList = [] // data.insurance;
    formData.studentServiceFeeCommissionDtoList = [] // data.serviceFee;
    formData.studentAccommodationCommissionDtoList = [] // data.accommodation;
    return formData;
  }
  public setSourceCurrencyDisableOption(num: string, key: string) {
    const list = this.formData.settlementCurrencyVoList;
    return list.some((item: any) => {
      if (item.key !== key) {
        return num === item.sourceCurrencyTypeNum;
      }
    });
  }

  public resetFormData() {
    this.formData = {
      fkAgentContractAccountId: "",
      optGuid: "",
      remark: "",
      flag: true,
      settlementCurrencyVoList: [
        {
          settlementModel: '', // 结算方式
          settlementCurrencyTypeNum: "", // 结算币种编号
          sourceCurrencyTypeNum: "", // 原币种编号
          key: new Date().getTime() + "",
        },
      ],
      studentAccommodationSubmitSettlementVoList: [
        {
          fkPayablePlanId: 0,
          statusSettlement: 0,
        },
      ],
      studentInsuranceSubmitSettlementVoList: [
        {
          fkPayablePlanId: 0,
          statusSettlement: 0,
        },
      ],
      studentOfferItemSettlementItemVoList: [
        {
          fkPayablePlanId: 0,
          statusSettlement: 0,
        },
      ],
      studentServiceFeeSubmitSettlementVoList: [
        {
          fkPayablePlanId: 0,
          statusSettlement: 0,
        },
      ],
    }
  }
  public handleClose() {
    this.resetFormData();
    if (this.loading) {
      this.$emit('update-data')
    }
    this.loading = false;
    this.$emit("changeVisible", false);
  }

  public checkHasFilled() {
    const formData = this.formData;
    if (formData.fkAgentContractAccountId && this.settleMethod) {
      this.$confirm(this.$t('index.submitSettlementTips') as string, this.$t('common.tip') as string, {
        confirmButtonText: this.$t('index.submitAndESign') as string,
        cancelButtonText: this.$t('common.confirm') as string,
        type: 'warning',
        showClose: true,
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        callback: (action) => {
          if (action === 'confirm') {
            this.submitAndESign();
          } else if (action === 'cancel') {
            this.handleClose();
          }
        }
      })
    } else {
      this.handleClose();
    }
  }
}
